import * as React from 'react'
import { css } from '@emotion/react'
import { colors, font, mq } from 'plume-ui'
import { desktopMinWidth } from '../../tokens/mediaquery'
import { FormattedDate } from '../../atoms/FormattedDate'

type Props = {
  publishedAt: string
}

export const TitledPublishedDate: React.FC<Props> = (props) => {
  return (
    <>
      <div
        css={css`
          display: flex;
          align-items: center;
          padding: 15px 20px 0;
          @media (min-width: ${desktopMinWidth}) {
            padding: 0;
          }
        `}
      >
        <div
          css={css`
            color: ${colors.textLight};
            font-size: 14px;
            font-weight: ${font.weight.normal};
            letter-spacing: 0.47px;
            padding: 0 3px;
            display: inline-block;
            line-height: 1;
            ${mq.large} {
              font-size: 16px;
            }
          `}
        >
          <FormattedDate>{props.publishedAt}</FormattedDate>
        </div>
      </div>
    </>
  )
}
